import { useAuthenticationStatus, useSignOut } from "@nhost/react";
import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const { signOut } = useSignOut();
  const { isAuthenticated, isLoading } = useAuthenticationStatus();
  return (
    <div className="text-xl font-semibold w-90 h-26 px-9 py-8 bg-emerald-400 flex justify-between align-middle">
      <div className="logo">
        <Link to="/">BLOGS</Link>
      </div>
      <div className="flex justify-end space-x-6">
        <div>
          <Link to="/myPost">My Blogs</Link>
        </div>
        <div>
          <Link to={"/editPost"}>Update Post</Link>
        </div>
        <br />
        <div>
          {isAuthenticated ? (
            <button
              className="outline-2 outline outline-offset-2 rounded-lg  w-auto h-auto"
              onClick={signOut}
            >
              Logout
            </button>
          ) : (
            <Link to={"/sign-in"}>Log in</Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
